import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import { getDataAttributes } from 'utils/utils';
import * as optimizelyUtil from 'utils/optimizely';
import './BookSelect.scss';

export default class BookSelect extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    value: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number,
    ]),
    options: PropTypes.array.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    onFieldBlur: PropTypes.func,
    data: PropTypes.object,
    isValid: PropTypes.bool,
    message: PropTypes.string,
    isSmall: PropTypes.bool,
    hideLabel: PropTypes.bool,
    isRequiredField: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    data: {},
    isRequiredField: false,
    disabled: false,
  }

  shouldComponentUpdate = shouldPureComponentUpdate;

  fireOptimizelyEvent = () => {
    const { data } = this.props;

    if (data.optimizelyId) {
      optimizelyUtil.fireEvent(`BookSelect${data.optimizelyId}`, 'clicked');
    }
  }

  render() {
    const {
      data,
      disabled,
      hideLabel,
      isRequiredField,
      isSmall,
      isValid,
      label,
      message,
      onFieldBlur,
      onFieldChange,
      options,
      value,
    } = this.props;

    const dataAttributes = data ? getDataAttributes(data) : {};

    return (
      <div className={`book-select ${isValid === false ? 'book-select--invalid' : ''} ${isValid ? 'book-select--valid' : ''} ${isSmall ? 'book-select--small' : ''}`}>
        <label className="book-select__label-wrap">
          <span className={`book-select__label ${hideLabel ? 'book-select__label--hide' : ''}`}>{label}{isRequiredField ? '*' : ''}</span>
          <div className="book-select__select-wrap">
            <select
              className={`book-select__select ${disabled ? 'book-select__select--disabled' : ''}`}
              disabled={disabled}
              value={value}
              onChange={onFieldChange}
              onBlur={onFieldBlur}
              onFocus={this.fireOptimizelyEvent}
              {...dataAttributes}
            >
              {
                options.map((item, index) =>
                  <option key={index} value={item.value} disabled={item.disabled}>{item.label}</option>)
              }
            </select>
          </div>
          {isValid === false && <span className="book-select__message">{message}</span>}
        </label>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/BookSelect/BookSelect.jsx
 **/